import { ViewStream, safeClone } from "spyne";
import View from "ramda/src/view";
import { UtilTraits } from "traits/util-traits";

export class CodePlaygroundMenuList extends ViewStream {
  constructor(props = {}) {
    // props.data['state'] = props.data;
    //console.log("PROPS DATA IS ",props);
    props.class = "code-playground-menu-list";
    props.data["__cms__isProxy"] = true;
    const { codeBlockDataSection } = props;

    const addSnakeCase = (obj) => {
      const d = safeClone(obj);
      const { menuTitle, referenceClassName, codeBlockDataSection } = d;

      d["pageId"] = String(codeBlockDataSection).toLowerCase();
      d["stage"] = String(referenceClassName).toLowerCase();
      d["classMethod"] = UtilTraits.util$ToKebabCase(menuTitle);
      return d;
    };

    //console.log('props data menu list ',props.data);

    props.data.state = props.data.state.map(addSnakeCase);

    //console.log('code cahnge ',props.data);

    if (codeBlockDataSection === "reference") {
      props.template = require("./template/code-playground-menu-reference.tmpl.html");
    } else {
      props.template = require("./template/code-playground-menu.tmpl.html");
    }

    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [];
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  checkForSubtitles() {
    const addSubtitle = (data, num, iter) => {
      const props = {
        tagName: "li",
        class: `menu-list-subtitle subtitle-${num}`,
        data,
        template: `<p class="text-h5 menu-subtitle">{{sectionSubtitle}}</p>`,
      };

      if (num === 0 && iter === 0) {
        this.prependView(new ViewStream(props), "ul.nested");
      } else {
        this.appendViewAfter(new ViewStream(props), `.menu-list-item-${num}`);
      }

      this.props.el$("ul").addClass("nested-1");
    };

    const checkForSubtitle = (o, i) => {
      const { sectionSubtitle } = o;
      //console.log("SUBTITLE ",{sectionSubtitle, i, o})

      if (sectionSubtitle) {
        const stateIndex = Math.max(0, i - 1);
        //console.log("index is ",{stateIndex, i});

        addSubtitle(o, stateIndex, i);
      }
    };

    this.props.data.state.forEach(checkForSubtitle);
  }

  onRendered() {
    /*
      if (this.props.data.state[0].sectionSubtitle){

        console.log("SUBTITLES ",this.props.data.state);


        this.prependView(new ViewStream(
                {tagName: 'p',
                  class: 'text-h5 menu-subtitle',
                  data: this.props.data.state[0],
                  template: `<b>{{sectionSubtitle}}</b>`
                }
            )
        );

        this.props.el$('ul').addClass('nested-1');
      }
*/

    if (this.props.data?.state[0]?.sectionTitle) {
      this.prependView(
        new ViewStream({
          tagName: "p",
          class: "text-h4",
          data: this.props.data.state[0],
          template: `<b>{{sectionTitle}}</b>`,
        }),
      );

      this.props.el$("ul").addClass("nested");
    }

    this.checkForSubtitles();
  }
}
